/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import Header from '../../../components/Groups/Header/Header';
import HomeLayout from '../../../components/Groups/Layout/HomeLayout/HomeLayout';
import MobileModalTrigger from '../../../components/Groups/Modals/MobileModalTrigger/MobileModalTrigger';
import HomePageWrapper from '../../../components/Groups/Navigation/HomePageWrapper/HomePageWrapper';
import HomeView from '../../../components/Groups/View/HomeView/HomeView';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

/* Statics */
import { GroupPropTypesShape } from '../../../components/Includes/GroupPropsShape';
/* Components */
import Layout from '../../../components/Layout/Layout';
import {
    FETCH_MODE_GROUP_FEED,
    Provider as CommunityProvider,
} from '../../../contexts/CommunityContext';
/* Contexts */
import { GroupConsumer, GroupProvider } from '../../../contexts/GroupContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { routes } from '../../../routes/routes';
/* Styles */
import './Home.scss';

import {
    ATTRIBUTION_MODE_CHERRYPICK,
    USER_RELATIONSHIP_ATTRIBUTION_ON,
} from '../../../contexts/AbstractContext';

export class Home extends React.PureComponent {
    constructor(props) {
        super(props);

        this.contentRef = React.createRef();

        this.state = {
            contentOffset: null,
        };
    }

    componentDidMount = () => this.getContentOffset();

    getContentOffset = () => {
        const contentOffset = this.contentRef.current.offsetTop;
        if (!contentOffset) return;
        const headerHeight = 56;
        const scrollPadding = 5;
        const adjustedOffset = contentOffset - (headerHeight + scrollPadding); // account for site header and add 5px padding
        this.setState({ contentOffset: adjustedOffset });
    };

    render() {
        const {
            PAGE_PROPS,
            group,
            userRelation,
            adminOnboardingProps,
            location,
        } = this.props;
        const { contentOffset } = this.state;
        const { paths, baseUrls } = routes.groups;

        const newAdminOnboardingProps = {
            ...adminOnboardingProps,
            showBanner: true,
        };

        const locationPath = location?.pathname;
        const isHomePage =
            locationPath === `/groups/${group.hash}/${group.slug}` ||
            locationPath === `/groups/${group.hash}`;
        return (
            <div className="page-Groups-Home">
                <SnowplowPageViewTracker
                    pageEntityId={group.hash}
                    pageSection={PAGE_VIEW_SECTIONS.GROUPS}
                    pageType={PAGE_VIEW_TYPES.FEED}
                />
                <PageConsumer>
                    {(pageContext) => {
                        const {
                            responsive,
                            modalTrigger,
                            pageProps,
                        } = pageContext;
                        const isMobileBreakpoint = responsive.atMost(1);
                        return (
                            <GroupProvider
                                PAGE_PROPS={PAGE_PROPS}
                                group={group}
                                userRelation={userRelation}
                            >
                                <CommunityProvider
                                    fetchMode={FETCH_MODE_GROUP_FEED}
                                    attributionMode={
                                        ATTRIBUTION_MODE_CHERRYPICK
                                    }
                                    content={[]}
                                    userRelationshipMode={
                                        USER_RELATIONSHIP_ATTRIBUTION_ON
                                    }
                                    topics={[]}
                                >
                                    <Layout
                                        {...this.props}
                                        displayDesktopFooter={false}
                                        topBannerOnlyShownList={[
                                            'admin-onboard',
                                        ]}
                                        adminOnboardingProps={
                                            newAdminOnboardingProps
                                        }
                                    >
                                        <GroupConsumer>
                                            {(groupContext) => (
                                                <HomePageWrapper
                                                    modalTrigger={modalTrigger}
                                                    isMobileBreakpoint={
                                                        isMobileBreakpoint
                                                    }
                                                    scrollOffset={contentOffset}
                                                >
                                                    <Header
                                                        useGenericLink={false}
                                                        group={
                                                            groupContext.group
                                                        }
                                                        userRelation={
                                                            groupContext.userRelation
                                                        }
                                                        hasPermission={
                                                            groupContext.hasPermission
                                                        }
                                                        isMember={
                                                            groupContext.isMember
                                                        }
                                                        acceptInvitation={
                                                            groupContext.acceptInvitation
                                                        }
                                                    />
                                                    <HomeLayout
                                                        modalTrigger={
                                                            pageContext.modalTrigger
                                                        }
                                                        featureFlags={
                                                            pageProps.featureFlags
                                                        }
                                                        innerRef={
                                                            this.contentRef
                                                        }
                                                    >
                                                        <Switch>
                                                            {baseUrls.map(
                                                                (baseUrl) =>
                                                                    paths.map(
                                                                        ({
                                                                            path,
                                                                            render,
                                                                        }) => (
                                                                            <Route
                                                                                exact
                                                                                key={`${baseUrl}${path}`}
                                                                                path={`${baseUrl}${path}`}
                                                                                render={
                                                                                    render
                                                                                }
                                                                            />
                                                                        )
                                                                    )
                                                            )}
                                                            {baseUrls.map(
                                                                (baseUrl) => (
                                                                    <Route
                                                                        exact
                                                                        key={
                                                                            baseUrl
                                                                        }
                                                                        path={
                                                                            baseUrl
                                                                        }
                                                                        render={() => (
                                                                            <HomeView />
                                                                        )}
                                                                    />
                                                                )
                                                            )}
                                                        </Switch>
                                                        <MobileModalTrigger
                                                            modalTrigger={(
                                                                modalData
                                                            ) =>
                                                                pageContext.modalTrigger(
                                                                    'GroupsMobileModal',
                                                                    {
                                                                        ...modalData,
                                                                        showPostButton: isHomePage,
                                                                        onClose: () =>
                                                                            pageContext.modalTrigger(),
                                                                    }
                                                                )
                                                            }
                                                            group={group}
                                                        />
                                                    </HomeLayout>
                                                </HomePageWrapper>
                                            )}
                                        </GroupConsumer>
                                    </Layout>
                                </CommunityProvider>
                            </GroupProvider>
                        );
                    }}
                </PageConsumer>
            </div>
        );
    }
}

Home.propTypes = {
    /**
     * the serialized group object
     */
    group: PropTypes.shape(GroupPropTypesShape),
    /**
     * object descriping the  user's relationship to the group
     */
    userRelation: PropTypes.shape({
        role: PropTypes.string,
    }),
    /**
     * the serialized content object
     */
    /* eslint-disable react/forbid-prop-types */
    content: PropTypes.object,
    /* eslint-disable react/forbid-prop-types */
    PAGE_PROPS: PropTypes.object.isRequired,
    /* eslint-disable react/forbid-prop-types */
    adminOnboardingProps: PropTypes.object,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
};

Home.defaultProps = {
    adminOnboardingProps: null,
    group: {},
    userRelation: {
        role: null,
    },
    content: null,
    location: null,
};

export default withRouter(Home);
